import "./Projects.css";

const GCS_BASE_URL = "https://storage.googleapis.com/portfolio-media-circus";

const projects = [
  {
    name: "Lumina",
    image: `${GCS_BASE_URL}/planetarium.jpg`,
    link: "/projects/lumina",
  },
  {
    name: "Giraffens Hjärta",
    image: `${GCS_BASE_URL}/corazon-de-jirafa-entrada.png`,
    link: "/projects/giraffenshjarta",
  },
];

function Projects() {
  return (
    <>
      <section className="projects">
        <div className="projects-grid">
          {projects.map((project) => (
            <a key={project.name} href={project.link} className="project-card">
              <img src={project.image} alt={project.name} />
              <p className="project-title">{project.name}</p>
            </a>
          ))}
        </div>
      </section>
    </>
  );
}

export default Projects;
